import React from 'react'
import OneAuthWrapper from './OneAuthWrapper'
import Auth0Wrapper from './Auth0Wrapper'

const ProtectedRoute: React.FunctionComponent<any> = ({
  component,
  ...args
}) => {
  const windowObj: any = window

  if (windowObj.REACT_APP_SSO_PROVIDER === 'auth0') {
    return <Auth0Wrapper Component={component} {...args} />
  }

  return <OneAuthWrapper Component={component} {...args} />
}

export default ProtectedRoute
